var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientePagadoraFacturadora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0c853;}.cls-2{fill:#4c74b6;}.cls-3{fill:#cbd75d;}.cls-4{fill:#f3f3e5;}.cls-5{fill:#d2dde6;}.cls-6{fill:#adbccb;}.cls-7{fill:#fbf59d;}.cls-8{fill:#9dcce6;}.cls-9{fill:#5e88b9;}.cls-10{fill:#f3d585;}.cls-11{fill:#fff;}.cls-12{fill:#5d646f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cliente_pagadora_facturadora") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.5,
    cy: 72.5,
    r: 72.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.29,89.44a41.67,41.67,0,0,1-41.64,40.25,40.74,40.74,0,0,1-5.41-.36A41.69,41.69,0,0,1,24,89.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.15,98.71l-2.88,5.75,2.88,4.31,5.74,2.88-4.31,7.18-4.31-1.43-3.69.44A41.44,41.44,0,0,1,24,89.44H50.33V93L46,94.4v2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.46,99.5v5.75l-4.31,2.88L80,112.44,84.34,111l5.75,1.44L93,105.25l-4.31-4.31,7.19-5.75-2.3-5.75h-15l-1.44,5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.16,123.71a41.5,41.5,0,0,1-21.51,6,40.74,40.74,0,0,1-5.41-.36l2.54-5.08V118.5l2.87-4.31,2.88,1.44L70,118.5l2.87,2.88h5.75l4.31-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.75,115.37a36.94,36.94,0,0,1-10.2-21.45l2.85-.34a34.17,34.17,0,0,0,9.42,19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.1,15.31H61.91V89.83H32.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.91,30.22h29.8V89.83H61.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49.49,22.77h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.55,22.77h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49.49,32.7h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.55,32.7h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49.49,42.64h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.55,42.64h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49.49,52.57h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.55,52.57h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49.49,62.51h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.55,62.51h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49.49,72.44h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.55,72.44h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79.29,37.67h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M69.36,37.67h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79.29,47.61h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M69.36,47.61h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79.29,57.54h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M69.36,57.54h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79.29,67.48h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M69.36,67.48h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79.29,77.41h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M69.36,77.41h5v5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124.73,113.35l-4.13,3.76-4.13-3.76-4.13,3.76-4.13-3.76-4.13,3.76L100,113.35l-4.13,3.76-4.13-3.76-4.12,3.76-4.13-3.76V62.69h41.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.21,85.21H121v15H87.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M111.6,85.21H121v15H111.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M106,85.21h5.63v15H106Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M129,67.29a9.38,9.38,0,1,1-9.38-9.38A9.38,9.38,0,0,1,129,67.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M123.36,64.47V62.6h-2.82V60.72h-1.88V62.6h-1.87a.94.94,0,0,0-.94.94v3.75a.94.94,0,0,0,.94.94h4.69V70.1h-5.63V72h2.81v1.88h1.88V72h1.88a.94.94,0,0,0,.94-.94V67.29a.94.94,0,0,0-.94-.94h-4.69V64.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M86.27,76.76h17.82v1.88H86.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M86.27,80.52H91.9v1.87H86.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M93.77,80.52h1.88v1.87H93.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M86.27,103h9.38v1.88H86.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M86.27,106.79h14.07v1.87H86.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M97.53,103H99.4v1.88H97.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M102.22,106.79H106v1.87h-3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M90,88h10.32V89.9H90Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M90,91.78h5.63v1.87H90Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M90,95.53H99.4V97.4H90Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M116.29,88h1.87V89.9h-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M114.41,91.78h3.75v1.87h-3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M114.41,95.53h3.75V97.4h-3.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientePagadoraFacturadora);
export default __webpack_public_path__ + "static/media/cliente_pagadora_facturadora.8df36375eb2e5510e037149198ff22e7.svg";
export { ForwardRef as ReactComponent };